module.exports = __webpack_public_path__ + "img/kdori_cover.cb0e1643.jpg";